<template>
  <div>
    <VSlickCarousel
      v-if="venue.photos && venue.photos.length"
      :arrows="true"
      v-bind="carouselOpts"
      swipe
      swipe-to-slide
    >
      <a
        v-for="(photo, idx) in venue.photos"
        :key="idx"
        href="#"
        draggable="false"
        class="venue-image relative block select-none overflow-hidden pb-62%"
        @click.prevent
        @mousedown="onMouseDown"
        @mouseup="e => onMouseUp(e, idx)"
      >
        <picture>
          <source v-if="photo.photo_rectangular_webp" :srcset="photo.photo_rectangular_webp" type="image/webp">
          <source :srcset="photo.photo_rectangular" type="image/jpeg">
          <img
            draggable="false"
            class="absolute size-full object-cover"
            :src="photo.photo_rectangular"
            :alt="venue.name"
            :loading="['sm', 'md'].includes($screen.name) && idx !== 0 ? 'lazy' : undefined"
          >
        </picture>
      </a>
    </VSlickCarousel>

    <CoolLightBox
      v-if="!['sm', 'md'].includes($screen.name)"
      :items="venue.photos.map(p => ({
        src: p.photo_rectangular,
        picture: {
          sources: [
            { srcset: p.photo_rectangular_webp, type: 'image/webp' },
            { srcset: p.photo_rectangular, type: 'image/jpeg' },
          ],
        },
      }))"
      :index="index"
      @close="index = null"
    />
  </div>
</template>

<script>
import { VSlickCarousel } from 'v-slick-carousel'
import CoolLightBox from '~/components/vendor/cool-lightbox/CoolLightBox.vue'

export default {
  components: { CoolLightBox, VSlickCarousel },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => ({
    index: null,
    dragged: false,
    mouseDownX: 0,
    mouseDownY: 0,
  }),

  computed: {
    carouselOpts () {
      switch (this.$screen.name) {
        case 'sm': return { centerMode: false, groupsToShow: 1, groupsToScroll: 1 }
        case 'md': return { centerMode: false, groupsToShow: 2, groupsToScroll: 2 }
        default: return { centerMode: true, groupsToShow: 3, groupsToScroll: 1 }
      }
    },
  },

  methods: {
    onMouseDown (e) {
      this.mouseDownX = e.screenX
      this.mouseDownY = e.screenY
    },

    onMouseUp (e, idx) {
      // This is to prevent click when dragging slides with mouse
      if (Math.abs(this.mouseDownX - e.screenX) < 5 && Math.abs(this.mouseDownY - e.screenY) < 5) {
        this.index = idx
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.venue-image { display: block !important; }

:deep() {
  // .slick-list { padding-left: 0 !important; }
  /*.slick-slide { margin: 0 5px; }*/

  .slick-prev, .slick-next { z-index: 2; margin-top: -15px; }
  .slick-prev:before, .slick-next:before {
    content: ''; display: block; width: 20px; height: 20px; border-top: 3px solid white; border-right: 3px solid white;
  }
  .slick-prev { left: 25px; transform: rotate(-135deg); }
  .slick-next { right: 25px; transform: rotate(45deg); }

  .cool-lightbox-toolbar__btn[title="Show thumbnails"] { display: none; }

  .cool-lightbox-button {
    width: 28px; height: 28px; padding: 4px !important; top: 50%; margin-top: -14px; opacity: 0.7;
    &:before {
      content: ''; display: block; width: 20px; height: 20px; border-top: 3px solid white; border-right: 3px solid white;
    }
    &.cool-lightbox-button--prev { transform: rotate(-135deg); margin-left: 10px; }
    &.cool-lightbox-button--next { transform: rotate(45deg); margin-right: 10px; }
    .cool-lightbox-button__icon { display: none; }
    &:hover { opacity: 1; }
  }
}
</style>
